export const states = {
  pending: {
    key: 'pending',
    label: 'Pending',
  },
  in_stock: {
    key: 'in_stock',
    label: 'In-stock',
  },
  installed: {
    key: 'installed',
    label: 'Installed',
  },
  retired: {
    key: 'retired',
    label: 'Retired',
  },
};
